import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import { twoFactorAuthTemplate } from "./template.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";

const DEFAULT_LEARN_MORE_URL =
  "https://www.crushftp.com/crush11wiki/Wiki.jsp?page=Authenticator";

const getSafeLearnMoreUrl = (url) => {
  if (!url || typeof url !== "string") return DEFAULT_LEARN_MORE_URL;
  try {
    const parsed = new URL(url.trim());
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return DEFAULT_LEARN_MORE_URL;
    }
    return parsed.href;
  } catch (e) {
    return DEFAULT_LEARN_MORE_URL;
  }
};

export default class TwoFactorAuthSetup {
  constructor() {
    this.QRTimer = null;
    this.UNIQUE_QR_ID = null;
    this.isQRCodeOpen = false;
  }

  renderTemplate = ({
    templateContainer,
    templateValues = {},
    onAfterTimeout = () => {},
  }) => {
    this.onAfterTimeout = onAfterTimeout;

    if (!templateContainer) return;
    _$(templateContainer).html(twoFactorAuthTemplate(templateValues));

    const learnMoreUrl = getSafeLearnMoreUrl(
      utils.getUserCustomizationValue("twofactor_learn_more_url", true)
    );
    _$("#twoFactorAuthLearnMore").attr("href", learnMoreUrl);

    _$("#resetQR").on("click", () => {
      this.renderQRcode();
    });
  };

  renderQRcode = () => {
    clearInterval(this.QRTimer);
    let seconds = 30;
    this.UNIQUE_QR_ID = utils.getUId();

    this.QRTimer = setInterval(() => {
      if (seconds === 0) {
        this.hide();
        this.onAfterTimeout();
        return;
      }
      _$("#twoFactorAuthQrCountDownValue").text(seconds);
      seconds--;
    }, 1000);

    const loader = new Loader({
      parentElement: "#twoFactorAuthQrCodeContainer",
    });

    _$("#twoFactorAuthUpdateQRText").addClass("is-hidden");

    const img = _$("#twoFactorAuthQrCode");
    img.attr("src", "");
    img.attr(
      "src",
      `/WebInterface/function/?command=getQR&c2f=${utils.cookie.get(
        "currentAuth"
      )}&qrid=${this.UNIQUE_QR_ID}`
    );

    img.on("load", () => {
      loader.deleteLoader();
      _$("#twoFactorAuthUpdateQRText").removeClass("is-hidden");
    });
  };

  hide = () => {
    this.isQRCodeOpen = false;

    clearInterval(this.QRTimer);
    _$("#twoFactorAuthQrCodeContainer").addClass("is-hidden");
    _$("#twoFactorAuthSetupButton").removeClass("is-hidden");
  };

  show = () => {
    this.isQRCodeOpen = true;

    this.renderQRcode();
    _$("#twoFactorAuthQrCodeContainer").removeClass("is-hidden");
    _$("#twoFactorAuthSetupButton").addClass("is-hidden");
  };

  addSetupButtonListener = (event = () => {}) => {
    _$("#twoFactorAuthSetupButton").on("click", event);
  };
}
